module.exports = __webpack_public_path__ + "static/media/AlumnicardBackGround.9be9f2de.svg";